import Vue from 'vue';
import Component from 'vue-class-component';
import { EventBus } from '~/utils/eventbus';

@Component({})
export default class MtpStatusReviewedModalComponent extends Vue {
    private selectedYesChanges: boolean = false;

    constructor() {
        super();
    }

    private updateChanges() {
        this.selectedYesChanges = false;
        this.$emit('clicked', false);
        EventBus.$emit(EventBus.MTP_STATUS.UPDATE_FLAGGED_MODAL, this.selectedYesChanges);

    }

    private onClickButton() {
        this.$emit('clicked', false);
    }
}
